import React from 'react';

import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { NoAvailableMessage } from 'app/shared/components/common/NoAvailableMessage';
import PropTypes from 'prop-types';

import { NO_AVAILABLE_SECTION_DATA_MESSAGE } from 'constants/messages';

import { ColumnIds, columnsDefs, DEFAULT_TABLE_TITLE } from './CreditsTable.constants';
import {
  tableBodyStyles,
  tableContainerStyles,
  tableHeadStyles,
  tableTitleStyles,
  tableWrapperStyles,
} from './CreditsTable.styles';

const CreditsTable = ({ dataItems, tableTitle = DEFAULT_TABLE_TITLE }) => {
  return (
    <Stack sx={tableWrapperStyles}>
      <Typography component="p" sx={tableTitleStyles} variant="bold16">
        {tableTitle}
      </Typography>

      <TableContainer sx={tableContainerStyles}>
        <Table>
          <TableHead sx={tableHeadStyles}>
            <TableRow>
              {columnsDefs.map(({ id, label, align, style }) => (
                <TableCell align={align} className="table-cell" key={id} sx={style}>
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody sx={tableBodyStyles}>
            {dataItems?.length ? (
              dataItems.map(({ id, name, amount }) => (
                <TableRow key={id}>
                  {columnsDefs.map(({ id, align }) => (
                    <TableCell align={align} className="table-cell" key={id}>
                      {id === ColumnIds.AMOUNT ? amount : name}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell align="center" className="table-cell" colSpan={2}>
                  <NoAvailableMessage message={NO_AVAILABLE_SECTION_DATA_MESSAGE} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

CreditsTable.propTypes = {
  dataItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      amount: PropTypes.string,
    }),
  ).isRequired,
  tableTitle: PropTypes.string,
};

export default CreditsTable;
